"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NumberHosts_1 = require("./NumberHosts");
var FirstHost_1 = require("./FirstHost");
var NetworkAddress_1 = require("./NetworkAddress");
var BroadcastAddress_1 = require("./BroadcastAddress");
var CidrToMask_1 = require("./CidrToMask");
var LastHost_1 = require("./LastHost");
var Mask_1 = require("./Mask");
function cidrInfo(subnet) {
    return {
        networkAddress: NetworkAddress_1.networkAddress(subnet),
        broadcastAddress: BroadcastAddress_1.broadcastAddress(subnet),
        numberHosts: NumberHosts_1.numberHosts(subnet, false),
        inclusiveNumberHosts: NumberHosts_1.numberHosts(subnet, true),
        firstHostAddress: FirstHost_1.firstHost(subnet),
        lastHostAddress: LastHost_1.lastHost(subnet),
        mask: Mask_1.mask(subnet),
        cidrMask: CidrToMask_1.cidrToMask(subnet)
    };
}
exports.cidrInfo = cidrInfo;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2lkckluZm8uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJDaWRySW5mby50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUNBLDZDQUEyQztBQUMzQyx5Q0FBdUM7QUFDdkMsbURBQWlEO0FBQ2pELHVEQUFxRDtBQUNyRCwyQ0FBeUM7QUFDekMsdUNBQXFDO0FBQ3JDLCtCQUE2QjtBQUU3QixrQkFBMEIsTUFBYztJQUN0QyxNQUFNLENBQUM7UUFDTCxjQUFjLEVBQUUsK0JBQWMsQ0FBQyxNQUFNLENBQUM7UUFDdEMsZ0JBQWdCLEVBQUUsbUNBQWdCLENBQUMsTUFBTSxDQUFDO1FBQzFDLFdBQVcsRUFBRSx5QkFBVyxDQUFDLE1BQU0sRUFBRSxLQUFLLENBQUM7UUFDdkMsb0JBQW9CLEVBQUUseUJBQVcsQ0FBQyxNQUFNLEVBQUUsSUFBSSxDQUFDO1FBQy9DLGdCQUFnQixFQUFFLHFCQUFTLENBQUMsTUFBTSxDQUFDO1FBQ25DLGVBQWUsRUFBRSxtQkFBUSxDQUFDLE1BQU0sQ0FBQztRQUNqQyxJQUFJLEVBQUUsV0FBSSxDQUFDLE1BQU0sQ0FBQztRQUNsQixRQUFRLEVBQUUsdUJBQVUsQ0FBQyxNQUFNLENBQUM7S0FDN0IsQ0FBQTtBQUNILENBQUM7QUFYRCw0QkFXQyJ9


//////////////////
// WEBPACK FOOTER
// ./src/CidrInfo.ts
// module id = 8
// module chunks = 0